import { useIntl } from '@capsicum/common';

export const useWCPledgeErrorModalTexts = () => {
	const { $t } = useIntl();
	const title = $t('worldChampionshipPledge.modals.error.title');
	const subtitle = $t('worldChampionshipPledge.modals.error.subtitle');
	const subtitleCancel = $t('worldChampionshipPledge.modals.error.subtitleCancel');
	const primaryButtonText = $t('worldChampionshipPledge.modals.error.primaryButtonText');
	const secondaryButtonText = $t('worldChampionshipPledge.modals.error.secondaryButtonText');

	return {
		primaryButtonText,
		secondaryButtonText,
		subtitle,
		subtitleCancel,
		title
	};
};
